import DisclaimerTemplate from './template';

export default function DisclaimerService(pl = {}, el) {
  if (!pl.notice && !pl.icons && !pl.poweredby) return;

  const disclaimerSlot = el.shadowRoot.querySelector('slot[name="disclaimer"]');
  disclaimerSlot.innerHTML = DisclaimerTemplate(pl);
  disclaimerSlot.hidden = false;
}
